import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../firebase.init';
import toast from 'react-hot-toast';
import { Headset, Send, MessageSquare, User } from 'lucide-react';
import '../../../assets/css/PremiumTools.css';

const BuyerCreateSupportTicket = () => {
    const navigate = useNavigate();
    const [user] = useAuthState(auth);
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // NEW
    const [ticketData, setTicketData] = useState({
        subject: '',
        message: '',
        ticketUserEmail: user?.email,
        ticketStatus: 'open',
        createdAt: new Date(),
        ticketUserRole: '',
        ticketUserName: '',
        ticketUserProfileURL: '',
    });

    useEffect(() => {
    const fetchUserData = async () => {
        if (user?.email) {
            try {
                const res = await fetch(`https://allinone-clone-7d5d795e98ce.herokuapp.com/users?userEmail=${user?.email}`);
                const data = await res.json(); // ✅ parse the response
                if (data && data.length > 0) {
                    const userInfo = data[0];
                    setUserData(userInfo);
                    setTicketData(prevData => ({
                        ...prevData,
                        ticketUserRole: userInfo.userRole || '',
                        ticketUserName: userInfo.userName || '',
                        ticketUserProfileURL: userInfo.profileURL || '',
                    }));
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
                toast.error("Error loading user data");
            }
        }
    };
    fetchUserData();
}, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true); // NEW
        try {
            const completeTicketData = {
                ...ticketData,
                ticketUserRole: userData?.userRole || ticketData.userRole,
                ticketUserName: userData?.userName || ticketData.userName,
                ticketUserProfileURL: userData?.profileURL || ticketData.profileURL,
            };

            await axios.post('https://allinone-clone-7d5d795e98ce.herokuapp.com/new-support-message', completeTicketData);
            toast.success('Support ticket created successfully');
            navigate('/user/support');
        } catch (error) {
            console.error('Error creating ticket:', error);
            toast.error('Failed to create support ticket');
        } finally {
            setIsLoading(false); // NEW
        }
    };

    return (
        <div className="premium-app-container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="glass-card border-0 shadow-lg">
                        <div className="card-body p-4 p-md-5">
                            <div className="d-flex align-items-center mb-4 gap-3">
                                <div className="icon-wrapper bg-primary bg-opacity-10 p-3 rounded-circle border border-primary border-opacity-25">
                                    <Headset size={32} className="text-primary" />
                                </div>
                                <div>
                                    <h3 className="mb-1 text-white fw-bold">Create Support Ticket</h3>
                                    <p className="text-white-50 mb-0">Submit a ticket and our support team will get back to you shortly.</p>
                                </div>
                            </div>
                            
                            {userData && (
                                <div className="glass-card mb-4 p-3 d-flex align-items-center gap-3">
                                    <img
                                        src={userData.profileURL}
                                        alt={userData.userName}
                                        className="rounded-circle border border-primary border-opacity-50 shadow-sm"
                                        style={{ width: '56px', height: '56px', objectFit: 'cover' }}
                                    />
                                    <div>
                                        <h5 className="mb-1 text-white fw-bold">{userData.userName}</h5>
                                        <span className="badge bg-primary bg-opacity-25 text-primary border border-primary border-opacity-25 px-2 py-1">{userData.userRole}</span>
                                    </div>
                                </div>
                            )}
                            
                            <form onSubmit={handleSubmit}>
                                <div className="mb-4">
                                    <label className="form-label text-white-50 fw-medium d-flex align-items-center gap-2">
                                        <MessageSquare size={16} /> Subject
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control glass-input text-white"
                                        value={ticketData.subject}
                                        onChange={(e) => setTicketData({ ...ticketData, subject: e.target.value })}
                                        placeholder="Briefly describe your issue..."
                                        required
                                    />
                                </div>
                                <div className="mb-5">
                                    <label className="form-label text-white-50 fw-medium d-flex align-items-center gap-2">
                                        <User size={16} /> Message
                                    </label>
                                    <textarea
                                        className="form-control glass-input text-white"
                                        rows="6"
                                        value={ticketData.message}
                                        onChange={(e) => setTicketData({ ...ticketData, message: e.target.value })}
                                        placeholder="Provide all the details we need to assist you..."
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-neon-primary w-100 py-3 fw-bold d-flex justify-content-center align-items-center gap-2 fs-5" disabled={isLoading}>
                                    {isLoading ? (
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <><Send size={22} /> Submit Ticket</>
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuyerCreateSupportTicket;
